// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"TextWidget_textWrapper__ly8Wb","pathway":"TextWidget_pathway__hZ5Na"};